'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

/**
 * TableRow component, used to display the rows of a table. Renders a native HTML tr element.
 *
 * @example
 * <TableRow>
 *   <TableCell>John</TableCell>
 *   <TableCell>25</TableCell>
 * </TableRow>
 */
const TableRow = forwardRef(function TableRow(rest, ref) {
    return jsx("tr", { ref: ref, ...rest });
});

export { TableRow };
